// Illustration system.
// Buffy poses: canonical character set pulled from the Figma character sheet
// (node 19:2 in the NEW UI file), backgrounds removed via edge flood-fill.
// UI-state mapping per the character board: waiting = loading/queue · sad = wrong
// answers · sleeping = idle · shrug = errors/empty states.
// Domain art: generated via Higgsfield, style-locked (soft matte 3D, blue + gold).
import buffaloCelebrate from './buffalo-celebrate.png';
import buffaloWave from './buffalo-wave.png';
import buffaloThink from './buffalo-think.png';
import buffaloStudy from './buffalo-study.png';
import buffaloWalk from './buffalo-walk.png';
import buffaloThumbsup from './buffalo-thumbsup.png';
import buffaloWaiting from './buffalo-waiting.png';
import buffaloSad from './buffalo-sad.png';
import buffaloSleeping from './buffalo-sleeping.png';
import buffaloShrug from './buffalo-shrug.png';
import domainGeotrig from './domain-geotrig.webp';
import domainData from './domain-data.webp';
import domainExpression from './domain-expression.webp';
import domainCraft from './domain-craft.webp';
import domainAdvanced from './domain-advanced.webp';

export const BUFFALO = {
  celebrate: buffaloCelebrate,
  wave: buffaloWave,
  think: buffaloThink,
  study: buffaloStudy,
  walk: buffaloWalk,
  thumbsUp: buffaloThumbsup,
  waiting: buffaloWaiting,
  sad: buffaloSad,
  sleeping: buffaloSleeping,
  shrug: buffaloShrug,
};

// Math (algebra) and Reading & Writing (info) are deliberately ABSENT: those two
// sections use the student home's subject art everywhere, so this set never
// supplies a competing Math or Reading illustration again. Per-domain art lives
// in StudentDashboardV3/assets/domainArt (DOMAIN_TOOL_ART).
export const DOMAIN_ART = {
  psda: domainData,
  advanced: domainAdvanced,
  geotrig: domainGeotrig,
  craft: domainCraft,
  conventions: domainCraft,
  expression: domainExpression,
};
